import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Header, Segment } from 'semantic-ui-react'
import styled from 'styled-components'

interface QuestionPreviewProps {
  children?: ReactElement | ReactElement[]
}

const QuestionWrapper = styled(Header)`
.ui.top.attached.header {
  margin-bottom: 0px !important;
 }

 .segment {
  margin: 0 0px !important;
  width: calc(100% + 0px) !important;
  max-width: calc(100% + 0px) !important;
 }

 .question-name {
  font-size: 15px !important;
  margin-bottom: 5px;
  border: 1px solid #e5e7eb;
  padding: 7px;
  border-radius: 5px;    
  color: #4183c4;
  cursor: grab !important;
  margin-left: 10px;
}
`

const QuestionPreview: React.FC<QuestionPreviewProps> = (props) => {
  const { t } = useTranslation()

  return <QuestionWrapper>
    <Header attached='top' block>
      <div>{t('Question Preview')}</div>
    </Header>
    <Segment attached>
      {props.children}
    </Segment>
  </QuestionWrapper>
}
export default QuestionPreview